import React from 'react'

import { PageHeading } from 'uiComponents/typography'
import OrdersSectionTabs from 'orders/sectionTabs'
import SearchField from 'uiComponents/search/searchField'
import CartTable from './cartTable'
import ErrorBoundary from 'uiComponents/errorBoundary'
import { useTranslation } from 'translations'

const Cart: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    return (
        <div id="cart__elem">
            <OrdersSectionTabs />
            <PageHeading>View, edit, resend emails of active carts.</PageHeading>
            <div style={{ paddingBottom: '2rem' }}>
                <SearchField placeholder={t('orders.cartOld.searchPlaceholder')} />
            </div>
            <div>
                <CartTable />
            </div>
            <ErrorBoundary>{children}</ErrorBoundary>
        </div>
    )
}

export default Cart
